import {Language} from '../components/navigation-bar/language-switcher/types/language-switcher.types';
import {Authority} from './user';

export class LoggedUser {
  id: number;
  username: string;
  token: string;
  language: Language;
  validUntil: Date;
  authorities: Authority[];

  constructor(
    id = null,
    username = '',
    token = '',
    language = Language.EN,
    validUntil = new Date(),
    authorities = [Authority.USER]
  ) {
    this.id = id;
    this.username = username;
    this.token = token;
    this.language = language;
    this.validUntil = validUntil;
    this.authorities = authorities;
  }
}
